import { render, staticRenderFns } from "./UnitOutOfServiceComponent.vue?vue&type=template&id=0df15b20&"
import script from "./UnitOutOfServiceComponent.vue?vue&type=script&lang=js&"
export * from "./UnitOutOfServiceComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports